import {
  Checkbox,
  FormField,
} from '@cloudscape-design/components';
import { getPathName } from 'features/plc/contracts/pressHMI.schema';
import { usePLCValue, usePLCWriteState } from 'features/plc/providers/PLCProvider';
import PropTypes from 'prop-types';
import React from 'react';

export default function PLCCheckboxEditor({ field }) {
  const { activeWrite, runWrite } = usePLCWriteState();
  const plcValue = usePLCValue(field.path);
  const handle = getPathName(field.path);

  return (
    // Add a hidden placeholder to align the checkbox with other fields
    <FormField label={<span aria-hidden="true">{'\u00A0'}</span>} stretch>
      <Checkbox
        checked={plcValue ?? false}
        disabled={activeWrite === handle}
        onChange={({ detail }) => runWrite({ path: field.path, value: detail.checked })}
        description={field.path?.description}
      >
        {field.label}
      </Checkbox>
    </FormField>
  );
}
PLCCheckboxEditor.propTypes = {
  field: PropTypes.shape({
    label: PropTypes.string.isRequired,
    path: PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      description: PropTypes.string,
    }).isRequired,
  }).isRequired,
};
